<template>
    <div>
        <div v-for="(one, index) in names" :key="index">
            <slot name="namesList" :firstName="one.firstName" :lastName="one.lastName" :alertName="alertName">
                <div @click=alertName(one.lastName)>{{one.firstName + ' ' + one.lastName}}</div>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "ListComponent",
    data() {
        return {
            names: {
                'id_1': {
                    id: 'id_1',
                    firstName: 'Name_1',
                    lastName: 'Last_name_1',
                    information: 'some information about Name_1'
                },
                'id_2': {
                    id: 'id_2',
                    firstName: 'Name_2',
                    lastName: 'Last_name_2',
                    information: 'some information about Name_2'
                },
            }
        }
    },
    created() {

    },
    methods:{
        alertName(name) {
            alert(name)
        },
        pressed(){
            alert('Pressed function from Child Component')
        }
    }
}
</script>

<style scoped>

</style>